// Funnel events to GA4 (gtag) and PostHog. purchase is sent server-side from the Stripe webhook.
export const track = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  if (window.gtag) window.gtag('event', name, params);
  if (window.posthog?.capture) window.posthog.capture(name, params);
};

export const trackOnce = (name, params = {}) => {
  const key = `pfc_evt_${name}`;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  track(name, params);
};

export const getGaClientId = () => {
  const m = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
  return m ? m[1] : null;
};

export const PREFILL_KEY = 'pfc_prefill';
